<mat-dialog-content>
  @for (photo of availableImages; track photo) {
    <div (click)="photoPicked(photo)" class="photo">
      @if (photo | usedBefore:otherImages; as counter) {
        <div class="alreadyUsed"
          [matTooltip]="'Zdjęcie zostało już wykorzystane '+ counter +' razy na tej ścianie'">
          {{counter}}
        </div>
      }
      @if (photoId===photo && currentCrop.value) {
        <img
          [ngStyle]="{'border-radius.%':rounding}"
      [src]="
                  {photoId:photo}
                    | getImageUrl
                      : (photo | getPhotoGroupFromPhotoId:imageRelations)
                      : 'anyone'
                      : context
                      : contextId
                      : 400
                    | async | cropCanvasPieceImage :currentCrop.value:photoId | async" />
      } @else {
        <img
        [src]="
                  {photoId:photo}
                    | getImageUrl
                      : (photo | getPhotoGroupFromPhotoId:imageRelations)
                      : 'anyone'
                      : context
                      : contextId
                      : 400
                    | async " />
        }
        @if (photoId===photo) {
          <div class="crop">
            <lib-button icon-only>
              <mat-icon>crop</mat-icon>
            </lib-button>
            <span>edytuj</span>
          </div>
        }
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <lib-button (click)="save()">Zapisz</lib-button>
    <lib-button bare mat-dialog-close>Anuluj</lib-button>
  </mat-dialog-actions>
